module.exports = __webpack_public_path__ + "static/img/dilogo.48c7f18.png";